var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalConfirmation',{on:{"confirm":_vm.removeHandler,"reject":_vm.onReject}})}
var staticRenderFns = []

export { render, staticRenderFns }